import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DblistService {

  listDeviceRecordingIntervalSource = new BehaviorSubject<ListDeviceRecordingInterval[]>([]);
  listDeviceRecordingInterval$ = this.listDeviceRecordingIntervalSource.asObservable();
  listFacilityTypeSource  = new BehaviorSubject<ListFacilityType[]>([]);
  listFacilityType$  = this.listFacilityTypeSource.asObservable();
  listPerAcreFootCostBasisForRechargeSource  = new BehaviorSubject<ListPerAcreFootCostBasisForRecharge[]>([]);
  listPerAcreFootCostBasisForRecharge$  = this.listPerAcreFootCostBasisForRechargeSource.asObservable();
  listRecorderTypeSource  = new BehaviorSubject<ListRecorderType[]>([]);
  listRecorderType$  = this.listRecorderTypeSource.asObservable();
  listPermitTypeSource  = new BehaviorSubject<ListPermitType[]>([]);
  listPermitType$  = this.listPermitTypeSource.asObservable();
  listProjectTypeSource = new BehaviorSubject<ListProjectType[]>([]);
  listProjectType$ = this.listProjectTypeSource.asObservable();
  listDiversionTypeSource = new BehaviorSubject<DiversionType[]>([]);
  listDiversionType$ = this.listDiversionTypeSource.asObservable();
  listTimeseriesDataTypeSource = new BehaviorSubject<ListTimeseriesDataType[]>([]);
  listTimeseriesDataType$ = this.listTimeseriesDataTypeSource.asObservable();
  
  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  getListDeviceRecordingInterval() {
    this.http.get<ListDeviceRecordingInterval[]>(`${this.baseUrl}api/list/getlistdevicerecordinginterval`).subscribe(
      response => {
        if (response) {
          this.changeListDeviceRecordingInterval(response)
        } else {
          this.changeListDeviceRecordingInterval([]);
        }
      },
      error => console.error(error)
    );
  }

  getListFacilityType() {
    this.http.get<ListFacilityType[]>(`${this.baseUrl}api/list/getlistfacilitytype`).subscribe(
      response => {
        if (response) {
          this.changeListFacilityType(response)
        } else {
          this.changeListFacilityType([]);
        }
      },
      error => console.error(error)
    );
  }

  getListPerAcreFootCostBasisForRecharge() {
    this.http.get<ListPerAcreFootCostBasisForRecharge[]>(`${this.baseUrl}api/list/getlistperacrefootcostbasisforrecharge`).subscribe(
      response => {
        if (response) {
          this.changeListPerAcreFootCostBasisForRecharge(response)
        } else {
          this.changeListPerAcreFootCostBasisForRecharge([]);
        }
      },
      error => console.error(error)
    );
  }
  getListRecorderType() {
    this.http.get<ListRecorderType[]>(`${this.baseUrl}api/list/getlistrecordertype`).subscribe(
      response => {
        if (response) {
          this.changeListRecorderType(response)
        } else {
          this.changeListRecorderType([]);
        }
      },
      error => console.error(error)
    );
  }
  getListPermitType() {
    this.http.get<ListPermitType[]>(`${this.baseUrl}api/list/getlistpermittype`).subscribe(
      response => {
        if (response) {
          this.changeListPermitType(response)
        } else {
          this.changeListPermitType([]);
        }
      },
      error => console.error(error)
    );
  }
  getListProjectType() {
    this.http.get<ListProjectType[]>(`${this.baseUrl}api/list/getlistprojecttype`).subscribe(
      response => {
        if (response) {
          this.changeListProjectType(response)
        } else {
          this.changeListProjectType([]);
        }
      },
      error => console.error(error)
    );
  }
  getListDiversionType() {
    this.http.get<DiversionType[]>(`${this.baseUrl}api/list/getdiversiontype`).subscribe(
      response => {
        if (response) {
          this.changeListDiversionType(response)
        } else {
          this.changeListDiversionType([]);
        }
      },
      error => console.error(error)
    );
  }
  getListTimeseriesDataType() {
    this.http.get<ListTimeseriesDataType[]>(`${this.baseUrl}api/list/getlisttimeseriesdatatype`).subscribe(
      response => {
        if (response) {
          this.changeListTimeseriesDataType(response)
        } else {
          this.changeListTimeseriesDataType([]);
        }
      },
      error => console.error(error)
    );
  }

  changeListDeviceRecordingInterval(listing: ListDeviceRecordingInterval[]) {
    this.listDeviceRecordingIntervalSource.next(listing);
  }
  changeListFacilityType(listing: ListFacilityType[]) {
    this.listFacilityTypeSource.next(listing);
  }
  changeListPerAcreFootCostBasisForRecharge(listing: ListPerAcreFootCostBasisForRecharge[]) {
    this.listPerAcreFootCostBasisForRechargeSource.next(listing);
  }
  changeListRecorderType(listing: ListRecorderType[]) {
    this.listRecorderTypeSource.next(listing);
  }
  changeListPermitType(listing: ListPermitType[]) {
    this.listPermitTypeSource.next(listing);
  }
  changeListProjectType(listing: ListProjectType[]) {
    this.listProjectTypeSource.next(listing);
  }
  changeListDiversionType(listing: DiversionType[]) {
    this.listDiversionTypeSource.next(listing);
  }
  changeListTimeseriesDataType(listing: ListTimeseriesDataType[]) {
    this.listTimeseriesDataTypeSource.next(listing);
  }
}

export interface ListDeviceRecordingInterval {
  listDeviceRecordingIntervalId: number,
  interval: string,
  intervalSeconds: number,
}
export interface ListFacilityType {
  listFacilityTypeId: number,
  name: string,
}
export interface ListPerAcreFootCostBasisForRecharge {
  listPerAcreFootCostBasisForRechargeId: number,
  name: string,
  description: string,
}
export interface ListRecorderType {
  listRecorderTypeId: number,
  name: string,
}
export interface ListPermitType {
  listPermitTypeId: number,
  name: string,
}
export interface ListProjectType {
  listProjectTypeId: number,
  name: string,
}
export interface DiversionType {
  diversionTypeId: number,
  name: string,
}
export interface ListTimeseriesDataType {
  listTimeseriesDataTypeId: number,
  name: string
}
